import Swiper from "swiper";
import setResized from './../helpers/set-resized';
import { resetMegamenu } from './general/megamenu';
import { gsap } from 'gsap';

export default () => {

	const buttons = document.querySelectorAll('.js-open-popup');
	const WRAPPER_VISIBLE_CLASS = 'popup-wrapper--visible';
	const VISIBLE_CLASS = 'popup--visible';
	const BODY_VISIBLE_CLASS = 'popup__body--visible';
	const WINDOW_VISIBLE_CLASS = 'popup__window--visible';
	const popupWrapperSelector = '.popup-wrapper';
	const popups = document.querySelectorAll('.popup');
	const header = document.querySelector('.js-header');
	let headerIsWhite = false;
	let headerIsScrolled = false;
	const headerIcons = header.querySelector('.js-header-icons');
	const headerSearch = header.querySelector('.js-header-search');
	const headerMenu = header.querySelector('.js-header-menu');
	const headerBg = header.querySelector('.header__bg');

	let buttonsSlider;
	const SLIDER_SPEED = 300;

	buttons.forEach(function(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();

			let popupName = btn.dataset.popup;
			let tab = +btn.dataset.tab;
			let popup = document.querySelector(`.popup[data-popup="${popupName}"]`);

			if (popup) {

				const popupBody = popup.querySelector('.popup__body');
				const popupWindow = popup.querySelector('.popup__window');

				resetMegamenu();
				popup.closest(popupWrapperSelector).classList.add(WRAPPER_VISIBLE_CLASS);
				popup.classList.add(VISIBLE_CLASS);
				document.body.classList.add('no-scroll');

				headerIsWhite = header.matches('.bg-white');
				headerIsScrolled = header.matches('.scrolled');
				if (popup.closest('main')) {
					if (!popupBody) {
						header.classList.remove('bg-white');
						header.classList.remove('scrolled');
					}
					else {
						headerBg.classList.add('open-popup');
						gsap.set(headerBg, {
							// width: window.innerWidth - popupBody.offsetWidth,
							scaleX: (window.innerWidth - popupBody.offsetWidth) / window.innerWidth,
						});
					}
				}

				if (popupBody) {
					popupBody.classList.add(BODY_VISIBLE_CLASS);
					header.style.pointerEvents = 'none';
					headerIcons.classList.add('is-invisible');
					if (window.innerWidth < 1260) headerMenu.classList.add('is-invisible');
					if (window.innerWidth < 1000) header.classList.add('is-invisible');

					if (!popup.querySelector('.popup__body--contact') &&
						!popup.querySelector('.popup__body--login') &&
						!popup.querySelector('.popup__body--cart')) {
							headerSearch.classList.add('is-invisible');
						}
				}

				if (popupWindow) {
					popupWindow.classList.add(WINDOW_VISIBLE_CLASS);
				}

				if (tab > -1) {
					const tabs = popup.querySelectorAll('.popup__button');
					if (tabs[tab]) {
						tabs[tab].click();
						if (window.innerWidth < 730) {
							buttonsSlider.slideTo(tab);
						}
					}
				}

			}
		});
	});

	popups.forEach(function(popup) {
		const closeBtns = popup.querySelectorAll('.js-close-popup, .popup__overlay');
		const buttons = popup.querySelectorAll('.popup__button');
		const tabs = popup.querySelectorAll('.popup__content');
		const tabsButtonsSliderEl = popup.querySelector('.js-tab-buttons-slider');

		if (closeBtns.length) {
			closeBtns.forEach(function(closeBtn) {
				closeBtn.addEventListener('click', (e) => {
					e.preventDefault();

					const popupBody = popup.querySelector('.popup__body');
					const popupWindow = popup.querySelector('.popup__window');
					let delay = 0;

					if (popupBody) {
						popupBody.classList.remove(BODY_VISIBLE_CLASS);
						delay = 600;
					}

					if (popupWindow) {
						popupWindow.classList.remove(WINDOW_VISIBLE_CLASS);
						delay = 400;
					}

					setTimeout(() => {
						popup.closest(popupWrapperSelector).classList.remove(WRAPPER_VISIBLE_CLASS);
						popup.classList.remove(VISIBLE_CLASS);

						let isVisiblePopup;
						popups.forEach(anotherPopup => {
							const isVisible = anotherPopup.matches(`.${VISIBLE_CLASS}`);
							if (isVisible) isVisiblePopup = true;
						});
						if (!isVisiblePopup) {
							document.body.classList.remove('no-scroll');
							header.style.pointerEvents = '';
							if (headerIsWhite) header.classList.add('bg-white');
							if (headerIsScrolled) header.classList.add('scrolled');
							headerIcons.classList.remove('is-invisible');
							headerSearch.classList.remove('is-invisible');
							headerMenu.classList.remove('is-invisible');
							header.classList.remove('is-invisible');
							headerBg.classList.remove('open-popup');
							gsap.set(headerBg, {
								// width: '100%',
								scaleX: 1,
							});
						}
					}, delay);
				});
			});
		}

		buttons.forEach(function(button, index) {
			button.addEventListener('click', (e) => {
				if (!button.classList.contains('popup__button--active')) {
					buttons.forEach(function(b) {
						b.classList.remove('popup__button--active');
					});
					tabs.forEach(function(t) {
						t.classList.remove('popup__content--visible');
					});

					button.classList.add('popup__button--active');
					tabs[index].classList.add('popup__content--visible');
				}

				if (buttonsSlider) {
					const left = button.getBoundingClientRect().left;
					const right = window.innerWidth - button.getBoundingClientRect().right;

					const prevSibl = button.previousElementSibling;
					const nextSibl = button.previousElementSibling;

					let widthLeft = 0;
					let widthRight = 0;
					if (prevSibl)
						widthLeft = prevSibl.offsetWidth;
					if (nextSibl)
						widthRight = nextSibl.offsetWidth;

					let newMove = buttonsSlider.translate;
					if (right < widthRight * 0.9 && !buttonsSlider.isEnd)
						newMove -= widthRight;
					else if (left < widthLeft * 0.9 && !buttonsSlider.isBeginning)
						newMove += widthLeft;

					buttonsSlider.translateTo(newMove, SLIDER_SPEED, false, false);
				}
			});
		});

		if (tabsButtonsSliderEl) {

			const wrapper = tabsButtonsSliderEl.querySelector('.js-tab-buttons-slider-wrapper');
			const slides = tabsButtonsSliderEl.querySelectorAll('.js-tab-buttons-slider-slide');

			setResized(() => {

				if (window.innerWidth < 730 && !buttonsSlider) {
					tabsButtonsSliderEl.classList.add('swiper');
					wrapper.classList.add('swiper-wrapper');
					slides.forEach(slide => {
						slide.classList.add('swiper-slide');
					});

					buttonsSlider = new Swiper(tabsButtonsSliderEl, {
						slidesPerView: 'auto',
						speed: SLIDER_SPEED,
					});
				}

				else if (window.innerWidth > 729 && buttonsSlider) {
					buttonsSlider.destroy();
					buttonsSlider = null;

					tabsButtonsSliderEl.classList.remove('swiper');
					wrapper.classList.remove('swiper-wrapper');
					slides.forEach(slide => {
						slide.classList.remove('swiper-slide');
					});
				}

			});
		}
	});
}

export function popupsReset() {

	const popups = document.querySelectorAll('.popup');
	if (!popups.length) return;

	popups.forEach(popup => {

		const closeBtn = popup.querySelector('.js-close-popup, .popup__overlay');
		closeBtn.click();

	});

}